module.exports = __webpack_public_path__ + "static/media/g2.08cba994.jpg";